import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Play, Send, ChevronRight } from 'lucide-react'
import type { Predication } from '@/types/Predication'
import YoutubeIcon from '@/components/icons/YoutubeIcon'

export default function PredicationCard({ id, titre, predicateur, date, serie, videoId }: Predication) {
  const [playing, setPlaying] = useState(false)
  // TODO: brancher l'URL YouTube réelle de chaque prédication (voir data/media.ts pour la vidéo de prévisualisation)
  const youtubeUrl = `https://www.youtube.com/watch?v=${videoId}`

  const handleShare = () => {
    const url = `${window.location.origin}/predications/${id}`
    const texte = `${titre} — écoutez cette prédication du CMP Lubumbashi : ${url}`
    window.open(`https://wa.me/?text=${encodeURIComponent(texte)}`, '_blank', 'noopener,noreferrer')
  }

  return (
    <div className="h-full flex flex-col bg-white rounded-2xl overflow-hidden shadow-[0_2px_10px_rgba(15,31,92,0.06)] ring-1 ring-cmp-navy/6">
      <div className="relative aspect-video bg-cmp-navy">
        {playing ? (
          // Lecteur de PRÉVISUALISATION (voir data/media.ts) — TODO: brancher la vraie vidéo de la prédication.
          <iframe
            className="w-full h-full"
            src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1`}
            title={titre}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        ) : (
          <button
            type="button"
            onClick={() => setPlaying(true)}
            aria-label={`Lire : ${titre}`}
            className="group relative w-full h-full flex items-center justify-center"
          >
            {/* Vignette Unsplash de PRÉVISUALISATION — TODO: remplacer par la vraie miniature */}
            <img src={`https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`} alt="" loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-cmp-navy/40 group-hover:bg-cmp-navy/30 transition-colors" />
            <span className="relative w-12 h-12 rounded-full bg-white/15 ring-1 ring-white/30 backdrop-blur-sm group-hover:bg-white/25 transition-colors flex items-center justify-center">
              <Play size={18} fill="white" color="white" className="ml-0.5" />
            </span>
            {serie && <span className="absolute top-2 left-2 bg-white/90 text-cmp-navy text-[10px] font-bold uppercase tracking-wide px-2 py-1 rounded-full">
              {serie}
            </span>}
          </button>
        )}
      </div>

      <div className="p-4 flex-1 flex flex-col">
        <p className="font-bold text-cmp-navy text-sm leading-snug">{titre}</p>
        <p className="text-gray-400 text-xs mt-1">{predicateur} · {date}</p>

        <div className="flex gap-2 pt-3 mt-auto">
          <Link
            to={`/predications/${id}`}
            className="flex-1 bg-cmp-navy text-white rounded-full py-2 text-xs font-semibold flex items-center justify-center gap-1 hover:bg-cmp-navy-light transition-colors active:scale-95"
          >
            Détails
            <ChevronRight size={12} />
          </Link>
          <a
            href={youtubeUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Voir sur YouTube"
            className="w-9 shrink-0 border border-cmp-navy/20 text-cmp-navy rounded-full flex items-center justify-center hover:bg-cmp-sky-light transition-colors active:scale-95"
          >
            <YoutubeIcon size={14} />
          </a>
          <button
            type="button"
            onClick={handleShare}
            aria-label="Partager sur WhatsApp"
            className="w-9 shrink-0 border border-cmp-navy/20 text-cmp-navy rounded-full flex items-center justify-center hover:bg-cmp-sky-light transition-colors active:scale-95"
          >
            <Send size={13} />
          </button>
        </div>
      </div>
    </div>
  )
}
